import { useParams, Navigate } from "react-router-dom";
import { PRODUCTS } from "@/src/constants/constants";
import { ProductDetail } from "./(sections)/ProductDetail";
import { ProductShowcase } from "./(sections)/ProductShowcase";
import { RelatedProducts } from "./(sections)/RelatedProducts";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function ProductPage() {
    const { id } = useParams<{ id: string }>();
    const product = PRODUCTS.find((p) => p.id === id);

    if (!product) return <Navigate to="/collection" replace />;

    return (
        <>
            <ProductDetail product={product} />
            <ProductShowcase productId={product.id} />
            <RelatedProducts currentId={product.id} />
            <Newsletter />
        </>
    );
}
